<template>

  <!-- 对话框 -->
  <el-dialog :visible.sync="show" width="60%" top="10vh" :before-close="closeDialog">

    <div v-for="(item,index) in nav_data" :key="index" v-if="item.checked">

      <p v-if="item.subs" style="margin-top: 20px; color:#606266;">[ {{item.title}} ]
      </p>
      <div v-else>
        <el-button type="text" @click="routerGo(item.index)" style="font-size:16px;margin-top: 20px;padding-left: 10px;color: #999;">
          {{item.title}} </el-button>
      </div>


      <div v-if="item.subs" class="nav-box">

        <el-button type="text" v-for="(item2,index) in item.subs" @click="routerGo(item2.index)"
          style="font-size: 16px;color: #999;">{{item2.title}}
        </el-button>

      </div>



    </div>



  </el-dialog>

</template>



<script>
  var _this;
  import {
    config
  } from '../../utils/config'; //配置
  import bus from '../common/bus';
  export default {
    props: {
      'isShow': Boolean,
      'data': ''
    },

    watch: {

      isShow(newData, oldData) {
        _this.show = true;
      }


    },
    data() {
      return {

        show: false,
        nav_data: [],

      };
    },
    created() {

      _this = this;

      _this.nav_data = JSON.parse(sessionStorage.getItem('navBar'));

    },
    methods: {

      // 关闭方法
      closeDialog() {

        _this.show = false;

      },

      // 网站地图跳转
      routerGo(index) {

        var path = "/" + index;
        this.$router.push(path);
        _this.closeDialog();

      }
    }
  };
</script>

<style scoped>
  .nav-box {
    margin-top: 10px;
    padding-left: 10px;
  }


  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }

  .el-collapse {
    border-bottom: 0;

  }

  .tag_group {
    display: block;
    width: 100%;
  }

  .collapse-content {
    margin: 10px 0;
    padding-left: 30px;
    box-sizing: border-box;
  }
</style>